{
  "GENERAL_SETTINGS": {
    "LIMIT_MESSAGES": {
      "CONVERSATION": "Túllépte a beszélgetési limitet. A Hacker csomag csak 500 beszélgetést engedélyez.",
      "INBOXES": "Túllépte a postafiók limitet. A Hacker csomag csak a webhelyen futó élő csevegést támogatja. További postafiókokhoz, mint e-mail, WhatsApp stb. fizetős csomag szükséges.",
      "AGENTS": "Túllépte az ügynök limitet. A Hacker csomag csak 2 ügynököt engedélyez.",
      "NON_ADMIN": "Kérje adminisztrátorát, hogy frissítse a csomagot, és továbbra is használhassa az összes funkciót."
    },
    "TITLE": "Fiókbeállítások",
    "SUBMIT": "Beállítások frissítése",
    "BACK": "Vissza",
    "DISMISS": "Elutasítás",
    "UPDATE": {
      "ERROR": "Beállítás frissítés sikertelen, kérjük próbáld később!",
      "SUCCESS": "Fiókbeállítások frissítve"
    },
    "ACCOUNT_DELETE_SECTION": {
      "TITLE": "Fiók törlése",
      "NOTE": "Miután törli a fiókját, minden adata törlésre kerül.",
      "BUTTON_TEXT": "Fiók törlése",
      "CONFIRM": {
        "TITLE": "Fiók törlése",
        "MESSAGE": "A fiók törlése visszafordíthatatlan. Adja meg a fiók nevét az alábbi mezőben a végleges törlés megerősítéséhez.",
        "BUTTON_TEXT": "Törlés",
        "DISMISS": "Mégse",
        "PLACE_HOLDER": "Gépelje be a megerősítéshez: {accountName}"
      },
      "SUCCESS": "A fiók törlésre lett megjelölve",
      "FAILURE": "Nem sikerült törölni a fiókot, próbálja újra!",
      "SCHEDULED_DELETION": {
        "TITLE": "A fiók törlése ütemezve",
        "MESSAGE_MANUAL": "A fiók törlésre lett ütemezve {deletionDate} napra. Ezt egy adminisztrátor kérte. A törlés ezen időpont előtt megszakítható.",
        "MESSAGE_INACTIVITY": "A fiók törlésre lett ütemezve {deletionDate} napra a fiók inaktivitása miatt. A törlés ezen időpont előtt megszakítható.",
        "CLEAR_BUTTON": "Ütemezett törlés megszakítása"
      }
    },
    "FORM": {
      "ERROR": "Kérjük javítsd ki az űrlaphibákat",
      "GENERAL_SECTION": {
        "TITLE": "Általános beállítások",
        "NOTE": ""
      },
      "ACCOUNT_ID": {
        "TITLE": "Fiók Azonosító",
        "NOTE": "Ez a személyazonosság akkor használható, ha API-alapú integrációt építesz"
      },
      "NAME": {
        "LABEL": "Fióknév",
        "PLACEHOLDER": "A fiókneved",
        "ERROR": "Kérjük helyes fióknevet adj meg"
      },
      "LANGUAGE": {
        "LABEL": "Oldal nyelve",
        "PLACEHOLDER": "A fiókneved",
        "ERROR": ""
      },
      "DOMAIN": {
        "LABEL": "Beérkező e-mail domain",
        "PLACEHOLDER": "A domain melyen az e-maileket fogadod",
        "ERROR": ""
      },
      "SUPPORT_EMAIL": {
        "LABEL": "Támogatási e-mail",
        "PLACEHOLDER": "A vállalati támogatási e-mailcímed",
        "ERROR": ""
      },
      "AUTO_RESOLVE_DURATION": {
        "LABEL": "A napok száma, mely után a ticketek automatikusan megoldódnak, ha nincs aktivitás",
        "NOTE": "Az inaktivitási órák száma, amely után minden nyitott beszélgetés automatikusan lezárul.",
        "PLACEHOLDER": "30",
        "ERROR": "Kérjük helyes auto feloldási időszakot adj meg (minimum 1 nap, maximum 999 nap)"
      },
      "AUTO_RESOLVE_EMPTY_DURATION": {
        "LABEL": "Azon napok száma, amely után egy üres beszélgetés automatikusan lezárul, ha nincs aktivitás",
        "PLACEHOLDER": "soha",
        "ERROR": "Adjon meg érvényes automatikus lezárási időtartamot (minimum 1 nap, maximum 999 nap)"
      },
      "FEATURES": {
        "INBOUND_EMAIL_ENABLED": "A beszélgetésfolytonosság e-maillel már elérhető a fiókodban.",
        "CUSTOM_EMAIL_DOMAIN_ENABLED": "Most már goadhatsz e-maileket az egyedi domaineden."
      },
      "PHONE": {
        "TITLE": "PBX beállítások",
        "NOTE": "Konfigurálja a kapcsolatot a PBX-szel telefonhívásokhoz",
        "SIP_HOST": {
          "LABEL": "SIP domain"
        },
        "DIALING_MODE": {
          "LABEL": "Tárcsázási mód",
          "MODES": {
            "direct": "Közvetlen - a hívás azonnal tárcsázásra kerül a telefonos hivatkozásra kattintva",
            "indirect": "Közvetett - a telefonszám a telefonvidzset beviteli mezőjébe kerül előkészítésre"
          }
        },
        "CALL_RECORDING_ACCESS": {
          "LABEL": "Hívásfelvétel hozzáférés",
          "MODES": {
            "admin_only": "Csak adminisztrátorok",
            "admin_and_assigned_agent": "Adminisztrátorok és a hozzárendelt ügynök",
            "inbox_members": "Minden ügynök, aki hozzáfér a postafiókhoz"
          }
        }
      },
      "EMAIL": {
        "TITLE": "E-mail beállítások",
        "NOTE": "Módosítja az e-mail postafiókok viselkedését"
      },
      "CONVERSATION_TIMESTAMP_DISPLAY_MODE": {
        "LABEL": "Beszélgetés időbélyeg megjelenítési módja",
        "MODES": {
          "both": "Létrehozás és utolsó aktivitás",
          "last_activity_only": "Csak utolsó aktivitás",
          "last_customer_message": "Utolsó ügyfélüzenet"
        }
      },
      "BLOCK_DOMAINS_WITH_LOW_REPUTATION": {
        "LABEL": "Alacsony reputációjú domainek blokkolása"
      },
      "INCLUDE_PREVIOUS_EMAIL_MESSAGE": {
        "LABEL": "Eredeti üzenet belefoglalása az e-mailre adott válaszba"
      },
      "RESOLVE_NEW_CONVERSATION": {
        "LABEL": "Új beszélgetés automatikus lezárása"
      },
      "MOVE_CONVERSATIONS_BY_ORDERS": {
        "LABEL": "Az új e-mailes beszélgetés automatikus áthelyezése annak a robotnak a postafiókjába, amely a kapcsolat rendeléseit feldolgozta"
      },
      "EXTENDED_LABELS": {
        "LABEL": "Kiterjesztett címkék - Hosszabb címkenevek engedélyezése nagyobb felugró felülettel"
      },
      "ENABLE_LAST_AGENT": {
        "LABEL": "LastAgent - A beszélgetés automatikus hozzárendelése ahhoz az ügynökhöz, aki az utolsó választ írta"
      },
      "PUSH_NOTIFICATION_MODE": {
        "LABEL": "Push értesítés mód",
        "MODES": {
          "all_inboxes": "Minden postafiók - Értesítések küldése minden csatornatípushoz",
          "chat_only": "Csak csevegés - Csak nem e-mail csatornákra küld értesítéseket"
        }
      },
      "ALLOW_TOGGLE_SIGNATURE": {
        "LABEL": "Aláírás váltásának engedélyezése küldött üzenetekben"
      },
      "WALLBOARD_CHAT_STATUS_ENABLED": {
        "LABEL": "Ügynök csevegési állapotának megjelenítése a wallboardon"
      },
      "SHOW_FULL_ATTACHMENT_NAMES": {
        "LABEL": "Teljes melléklet nevek megjelenítése csonkolás nélkül"
      },
      "PASSWORD_LOGIN_MODE": {
        "LABEL": "Jelszavas bejelentkezés",
        "MODES": {
          "allowed_for_all": "Minden felhasználó számára engedélyezett",
          "allowed_for_agents_only": "Csak ügynökök számára engedélyezett (adminoknak OAuth-ot kell használniuk)",
          "password_login_disabled": "Letiltva - csak OAuth"
        }
      }
    },
    "NEW_VERSION_AVAILABLE": "Új verzió elérhető. Töltse újra az oldalt a legújabb frissítések letöltéséhez.",
    "RELOAD_NOW": "Frissítés most",
    "LEARN_MORE": "Tudj meg többet",
    "PAYMENT_PENDING": "A fizetése folyamatban van. Kérjük, frissítse fizetési adatait a szoftver használatának folytatásához",
    "LIMITS_UPGRADE": "Fiókja túllépte a használati korlátokat. Kérjük, váltson magasabb csomagra a szoftver használatának folytatásához",
    "OPEN_BILLING": "Számlázási beállítások megnyitása"
  },
  "FORMS": {
    "MULTISELECT": {
      "ENTER_TO_SELECT": "Enter-rel válaszd ki",
      "ENTER_TO_REMOVE": "Enter-rel távolítsd el",
      "NO_OPTIONS": "A lista üres",
      "NO_RESULT": "Nincs találat",
      "SELECT_ONE": "Válassz egyet",
      "SELECT": "Kiválasztás"
    }
  },
  "NOTIFICATIONS_PAGE": {
    "HEADER": "Értesítések",
    "MARK_ALL_DONE": "Mind kész",
    "DELETE_TITLE": "törölve",
    "UNREAD_NOTIFICATION": {
      "TITLE": "Olvasatlan értesítések",
      "ALL_NOTIFICATIONS": "Összes értesítés nézete",
      "LOADING_UNREAD_MESSAGE": "Olvasatlan értesítések betöltése...",
      "EMPTY_MESSAGE": "Nincs olvasatlan értesítésed"
    },
    "LIST": {
      "LOADING_MESSAGE": "Értesítések betöltése...",
      "404": "Nincs értesítés",
      "TABLE_HEADER": [
        "Név",
        "Telefonszám",
        "Beszélgetések",
        "Utoljára kapcsolatban"
      ]
    },
    "TYPE_LABEL": {
      "conversation_creation": "Új beszélgetés",
      "conversation_assignment": "Beszélgetés hozzárendelve",
      "assigned_conversation_new_message": "Új üzenet",
      "participating_conversation_new_message": "Új üzenet",
      "conversation_mention": "Megemlítés",
      "sla_missed_first_response": "SLA elmulasztva",
      "sla_missed_next_response": "SLA elmulasztva",
      "sla_missed_resolution": "SLA elmulasztva"
    }
  },
  "NETWORK": {
    "NOTIFICATION": {
      "OFFLINE": "Offline",
      "RECONNECTING": "Újracsatlakozás...",
      "RECONNECT_SUCCESS": "Újracsatlakozva"
    },
    "BUTTON": {
      "REFRESH": "Frissítés"
    },
    "CONNECTION_LOST": {
      "TITLE": "A kapcsolat megszakadt",
      "DESCRIPTION": "Nem sikerült elérni a kiszolgálót. Ellenőrizd a kapcsolatot, és próbáld újra.",
      "RETRY": "Próbáld újra"
    }
  },
  "COMMAND_BAR": {
    "SEARCH_PLACEHOLDER": "Keresés vagy ugrás ide:",
    "SECTIONS": {
      "GENERAL": "Általános",
      "REPORTS": "Jelentések",
      "CONVERSATION": "Beszélgetés",
      "BULK_ACTIONS": "Tömeges műveletek",
      "CHANGE_ASSIGNEE": "Felelős megváltoztatása",
      "CHANGE_PRIORITY": "Prioritás megváltoztatása",
      "CHANGE_TEAM": "Csapat megváltoztatása",
      "SNOOZE_CONVERSATION": "Beszélgetés alvómódba",
      "EXECUTE_MACRO": "Makró végrehajtása",
      "ADD_LABEL": "Címke hozzáadása a beszélgetéshez",
      "REMOVE_LABEL": "Címke eltávolítása a beszélgetésről",
      "SETTINGS": "Beállítások",
      "AI_ASSIST": "AI segítség",
      "APPEARANCE": "Megjelenés",
      "SNOOZE_NOTIFICATION": "Értesítés halasztása"
    },
    "COMMANDS": {
      "GO_TO_CONVERSATION_DASHBOARD": "Ugrás a beszélgetések kezdőoldalára",
      "GO_TO_CONTACTS_DASHBOARD": "Ugrás a kapcsolatok kezdőoldalára",
      "GO_TO_REPORTS_OVERVIEW": "Ugrás a jelentések áttekintésére",
      "GO_TO_CONVERSATION_REPORTS": "Ugrás a beszélgetések kezdőoldalára",
      "GO_TO_AGENT_REPORTS": "Ugrás ügynök jelentésére",
      "GO_TO_LABEL_REPORTS": "Ugrás címke jelentésére",
      "GO_TO_INBOX_REPORTS": "Ugrás beérkező levelek jelentésére",
      "GO_TO_TEAM_REPORTS": "Ugrás csapat jelentésére",
      "GO_TO_SETTINGS_AGENTS": "Ugrás az ügynük beállításaira",
      "GO_TO_SETTINGS_TEAMS": "Csapat beállítások megnyitása",
      "GO_TO_SETTINGS_INBOXES": "Fiók beállítások megnyitása",
      "GO_TO_SETTINGS_LABELS": "Cimke beállítások megnyitása",
      "GO_TO_SETTINGS_CANNED_RESPONSES": "Sablonválasz beállítások megnyitása",
      "GO_TO_SETTINGS_APPLICATIONS": "Alkalmazás beállítások megnyitása",
      "GO_TO_SETTINGS_ACCOUNT": "Fiók szintű beállítások megnyitása",
      "GO_TO_SETTINGS_PROFILE": "Profil beállítások megnyitása",
      "GO_TO_NOTIFICATIONS": "Értesítések megnyitása",
      "ADD_LABELS_TO_CONVERSATION": "Cimke hozzáadása a beszélgetéshez",
      "ASSIGN_AN_AGENT": "Ügynök hozzárendelése",
      "AI_ASSIST": "AI segítség",
      "ASSIGN_PRIORITY": "Prioritás beállítása",
      "ASSIGN_A_TEAM": "Csapat hozzárendelése",
      "EXECUTE_A_MACRO": "Makró végrehajtása",
      "MUTE_CONVERSATION": "Beszélgetés némítása",
      "UNMUTE_CONVERSATION": "Beszélgetés némításának feloldása",
      "REMOVE_LABEL_FROM_CONVERSATION": "Cimke eltávolítása a beszélgetésről",
      "REOPEN_CONVERSATION": "Beszélgetés újranyitása",
      "RESOLVE_CONVERSATION": "Beszélgetés megoldása",
      "SEND_TRANSCRIPT": "E-mail átirat küldése",
      "SNOOZE_CONVERSATION": "Beszélgetés alvómódba",
      "UNTIL_NEXT_REPLY": "Következő válaszig",
      "UNTIL_NEXT_WEEK": "Jövő hétig",
      "UNTIL_TOMORROW": "Holnapig",
      "UNTIL_NEXT_MONTH": "Következő hónapig",
      "AN_HOUR_FROM_NOW": "Mostantól egy óráig",
      "UNTIL_CUSTOM_TIME": "Speciális...",
      "CHANGE_APPEARANCE": "Megjelenés módosítása",
      "LIGHT_MODE": "Világos mód",
      "DARK_MODE": "Sötét mód",
      "SYSTEM_MODE": "Rendszer",
      "SNOOZE_NOTIFICATION": "Értesítés halasztása"
    }
  },
  "DASHBOARD_APPS": {
    "LOADING_MESSAGE": "Kezelőoldal App betöltése..."
  },
  "COMMON": {
    "OR": "Vagy",
    "CLICK_HERE": "kattints ide"
  }
}
